
import { HttpService } from 'app/components/data/DataSource/Remote/HttpService'
import { RemotePagingDataSource } from 'app/components/data/DataSource/Remote/Paging'
import { RemoteStaticDataSource } from 'app/components/data/DataSource/Remote/Static'

export {
  RemotePagingDataSource,
  RemoteStaticDataSource,
  HttpService
}



// WEBPACK FOOTER //
// ./src/app/components/data/DataSource/Remote/index.ts